<template>
    <router-view></router-view>
</template>

<script>
import axios from "axios";
import store from './store'
import router from './routes/router';

export default {
    methods: {
        loadBasicData() {
            if (this.$store.getters['customer/needUpdate']) {
                this.$store.dispatch('customer/loadUser');
            }

            if (this.$store.getters['voicemail/needUpdate']) {
                this.$store.dispatch('voicemail/loadVoicemails');
            }
            if (this.$store.getters['timecondition/needUpdate']) {
                this.$store.dispatch('timecondition/load');
            }
        }
    },
    mounted() {
        this.$rtl.disableRTL();

        axios.interceptors.response.use(function (response) {
            return response;
        }, function (error) {
            if (401 === error.response.status) {
                store.dispatch('AUTH_LOGOUT').then(() => {
                    router.push('/login');
                });
            } else {
                return Promise.reject(error);
            }
        });

        if (this.$store.getters.isAuthenticated && localStorage.getItem('permissions') !== 'teacher') {
            this.loadBasicData();
        }

    },
};
</script>
